import { ReactElement } from 'react'
import ReactDOMCompat from './ReactCompat';

export function renderToBody(element: ReactElement) {
  const container = document.createElement('div')
  document.body?.appendChild(container)
  function unmount() {
    const unmountResult = ReactDOMCompat.unmount(container)
    if (unmountResult && container.parentNode) {
      container.parentNode.removeChild(container)
    }
  }
  ReactDOMCompat.render(element, container)
  return unmount
}
